"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout3 = exports.Layout2 = exports.Layout4 = void 0;
var react_1 = __importDefault(require("react"));
require("./index.less");
/**
 * 四分主区域
 * @returns
 */
function Layout4(props) {
    var style = {};
    if (props.mt != undefined && props.mt > 0) {
        style.marginTop = props.mt + 'px';
    }
    return (react_1.default.createElement("div", { className: "layout4 scf", style: style }, props.children));
}
exports.Layout4 = Layout4;
//四分主区域-子项
Layout4.Item = function (props) {
    return (react_1.default.createElement("div", { className: "layout4_item" }, props.children));
};
/**
 * 二分主区域
 * @returns
 */
function Layout2(props) {
    var style = {};
    if (props.mt != undefined && props.mt > 0) {
        style.marginTop = props.mt + 'px';
    }
    return (react_1.default.createElement("div", { className: "layout2 scf", style: style }, props.children));
}
exports.Layout2 = Layout2;
//四分主区域-子项
Layout2.Item = function (props) {
    return (react_1.default.createElement("div", { className: "layout2_item" }, props.children));
};
/**
 * 三分位区域
 * @param props
 * @returns
 */
function Layout3(props) {
    var style = {};
    if (props.mt != undefined && props.mt > 0) {
        style.marginTop = props.mt + 'px';
    }
    return (react_1.default.createElement("div", { className: "layout3 scf", style: style }, props.children));
}
exports.Layout3 = Layout3;
Layout3.Item = function (props) {
    return (react_1.default.createElement("div", { className: "layout3_item" }, props.children));
};
